import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import ModalWindow from '../Window';
import { darken } from '@material-ui/core/styles/colorManipulator';
import getPrettyError from '../../utils/getPrettyError';

var styles = function styles(theme) {
  return {
    content: {
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    },
    button: {
      backgroundColor: theme.getColor('danger'),
      '&:hover': {
        backgroundColor: darken(theme.getColor('danger'), 0.2)
      }
    }
  };
};
/**
 * A delete confirmation dialog
 * @param {import('modal/variants/types').DeleteConfirmationProps & import('modal/types').ModalProps & import('@material-ui/core').WithStyles<typeof styles>} props
 */


var DeleteConfirmation = function DeleteConfirmation(props) {
  var onClose = props.onClose,
      onDelete = props.onDelete,
      message = props.message,
      title = props.title,
      submitLabel = props.submitLabel,
      submittingLabel = props.submittingLabel,
      classes = props.classes;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      errorResponse = _useState2[0],
      setError = _useState2[1];

  var deleteFn = function deleteFn(e) {
    if (errorResponse) setError(null);
    return onDelete(e).catch(function (action) {
      setError(getPrettyError(action));
      throw action;
    });
  };

  return React.createElement(ModalWindow, {
    onClose: onClose,
    borderLess: true,
    overlay: true,
    header: title,
    error: errorResponse,
    content: React.createElement("div", {
      className: classes.content
    }, message),
    footerButtons: {
      submit: {
        children: submitLabel,
        pendingChildren: submittingLabel,
        className: classes.button,
        onClick: deleteFn
      },
      cancel: {}
    }
  });
};

DeleteConfirmation.defaultProps = {
  title: 'Delete?',
  message: 'Are you sure you want to delete?',
  submitLabel: 'Delete',
  submittingLabel: 'Deleting...'
};
export default withStyles(styles, {
  name: 'ECDeleteConfirmation'
})(DeleteConfirmation);